import halifax from './cities/halifax'

export default {
  'province': 'Nova Scotia',
  'abbr': 'N.S.',
  'alpha': 'NS',
  'writeup': '',
  'lawSociety': `Nova Scotia Barrister's Society`,
  'cities': [
    halifax
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/novaScotia/index.js